import moment from 'moment/moment';
import React from 'react';
import commonIcons from '../api/images/icons';
import {convertBigNumToDecimalString} from '../utils/convert-decimal-to-big-num';
import timeFormAPI from '../api/ui/timeFormAPI';
import {InitialEventState} from './event';
import stateIcons from "../api/images/stateIcons";



// JUST_NOW_DATE_TIMES 상수가 애플리케이션 시작 시 한 번만 초기화 되는 이슈로 코드 수정
const getCurrentUTCDateTime = () => moment.utc().format('YYYY-MM-DDTHH:mm');

export const JUST_NOW_DATE_TIMES = {
    get value() {
        return getCurrentUTCDateTime();
    }
};
export const JUST_NOW_TIMES = moment.utc().format('HHmm');

export const TODAY_START_AT = moment.utc().format('YYYY-MM-DDT00:00:00');
export const TODAY_END_AT = moment.utc().format('YYYY-MM-DDT23:59:59');

export const DAYS_AGO = (days) => {
    return moment().subtract(days, 'days').format('YYYY-MM-DD');
}

let historyIcon;
let difference;
let textColor
export const DIFF_VALUE = (a, b) => {

    // a 또는 b가 undefined일 경우 0으로 대치
    a = a !== undefined ? a : 0;
    b = b !== undefined ? b : 0;

    // b의 날짜가 없을경우 어제 기준이라고 강제 표기
    // date = date !== undefined ? date : DAYS_AGO(1);

    if (a > b) {
        historyIcon = <img src={commonIcons.histroyDownIcon} alt={'down'} style={{width: 16, height: 16}}/>;
        difference = -1 * (b - a);
        textColor = '#0A7EE9';
    } else if (a < b) {
        historyIcon = <img src={commonIcons.histroyUpIcon} alt={'up'} style={{width: 16, height: 16}}/>;
        difference = b - a;
        textColor = '#E90A32';
    } else {
        historyIcon = '-';
        difference = 0;
        textColor = '#141414';
    }

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
            {historyIcon}
            <p style={{color: textColor, fontSize: 12, fontWeight: 400}}>
                {difference.toFixed(2)}
            </p>
            {/* <p style={{ color: '#787878', fontSize: 10, fontWeight: 400 }}> */}
            {/*   { `(${timeFormAPI.changeDataDate(date)}) 기준` } */}
            {/* </p> */}
        </div>
    );
}

// 불필요해 보임으로 사용 중지. 필요시 코드 수정된 코드로 재적용 필요
// export const classNameStrings = (title, className) => {
//   const classNames = {
//     "마켓": {
//       tab1: '차량',
//       tab2: '차량 상자',
//       tab3: '아이템',
//       tab4: '보석',
//     },
//     // 다른 타이틀에 대한 탭 정의를 여기에 추가할 수 있습니다.
//   };
//
//   // 해당 타이틀에 대한 클래스 이름이 있으면 반환, 없으면 기본값 반환
//   return `${title} - ${classNames[title]?.[className]}` || `${title} - ${className}`;
// };

export const STATISTICS_TRANSACTION_TYPES = [
    {key: '-9999', value: '생성'},
    {key: '106', value: '스페셜 상자 오픈 보상'},
    {key: '23', value: '온체인 예치'},
    {key: '131', value: '우편 보상 수령'},
    {key: '122', value: 'NFT 판매'},
    {key: '124', value: '아이템 판매'},
    {key: '130', value: '채굴'},
    {key: '140', value: '이벤트 보상 획득'},
    {key: '-9998', value: '소각'},
    {key: '101', value: '차량 레벨업'},
    {key: '102', value: '차량 레벨업 가속'},
    {key: '105', value: '스페셜 상자 열기'},
    {key: '103', value: '차량 수리'},
    {key: '104', value: '차량 복원'},
    {key: '113', value: '보석 업그레이드'},
    {key: '14', value: '온체인 인출'},
    {key: '121', value: 'NFT 구매'},
    {key: '123', value: '아이템 구매'},
    {key: '15', value: '소각 수수료(전송)'},
    {key: '112', value: '이볼브'},
    {key: '141', value: '이벤트 참여 소모'},
    {key: '114', value: '보석 소켓 변경'},
    {key: '111', value: '브리드'},
    {key: '115', value: 'NFT 스탯 초기화'},
];

export const SELECT_FORM_STYLE = {
    padding: 5,
    margin: 'unset',
    width: 'fit-content',
    maxWidth: 180,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    border: '1px solid #CDCDD1',
    color: '#787878',
    fontWeight: 400,
    fontSize: 14,
}

// 날짜 범위 요청 후 서버로 부터 온 날짜 중 빈 날짜 자동 생성기(시작일자와 List의 Index 입력)
export const CALCULATE_EMPTY_DATE = (startDate, index) => {
    const emptyDate = new Date(startDate);
    emptyDate.setDate(emptyDate.getDate() + index);
    return emptyDate.toISOString().split('T')[0];
}

// 하바 주소
export const HAVAH_ROUTE_URL_LIVE = 'https://prod.api.havahswap.io/swap/route';
export const DEST_USDT = 'cx3a60a0435b1c11265d69994188f33f043a789397'; // usdt
export const ORIGIN_TOKEN = {
    LIVE: {
        PER: 'cxd7fed2ae1d9b2314087520efe1870c33e5c5baa4',
        XPER: 'cx845d39382f26509a4db7af8e3b38159f9c533852',
    },
    TEST: {
        PER: 'cx55fe1cd2a2d36f2233d2cef077b1e06d2e7f233c',
        XPER: 'cx6543c9d479c025fbde1d38e0bb7b2ca758053e15',
    },
};

// 친구 추천 타입
export const INVITATION_TYPES = [
    {key: 1, value: '기존 친구 추천 보상'},
    {key: 2, value: 'NFT 구매 보상 + 기존 추천 보상'},
    {key: 4, value: '파트너사 추천 보상'},
];

// 타입 별 값 반환
export function getInvitationTypeValue(key) {
    const type = INVITATION_TYPES?.find(item => item.key === key);
    return type ? type?.value : '매칭하는 추천 이벤트 타입이 없습니다.';
}

// 토큰 타입
//export const TokenType = {
//     0: 'HVH',
//     1: 'PER',
//     2: 'XPER',
//     3: 'PERPLAY',
//     4: 'GEAR',
//     5: 'USDT',
//     6: 'ARB',
//
//     100: 'CASH',
//     200: 'ITEM',
// }
export const TOKEN_TYPES = [
    {key: 0, value: 'HVH'},
    {key: 1, value: 'PER'},
    {key: 2, value: 'XPER'},
    {key: 3, value: 'PERPLAY'},
    {key: 4, value: 'GEAR'},
    {key: 5, value: 'USDT'},
    {key: 6, value: 'ARB'},
    {key: 100, value: 'PP'},
    {key: 200, value: 'ITEM'},
];

export function getTokenTypeName(key) {
    const type = TOKEN_TYPES?.find(item => item.key === key);
    return type ? type?.value : key;
}



export const STORAGE_TYPE = [
    {key: 0, value: 'nft-storage'},
    {key: 1, value: 'game-campaign'},
    {key: 2, value: 'perplay-hub'},
];


export const CASH_LOG_TYPE = [
    {key: 1, value: '충전'},
    {key: 2, value: '충전 취소'},
    {key: 3, value: '인출'},
    {key: 4, value: '소멸'},
    {key: 100, value: '사용-렌탈'},
];

export function cashLogTypeToString(key) {
    const type = CASH_LOG_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}

export const WITHDRAWAL_TYPE = [
    {key: 0, value: '정상 회원'},
    {key: 1, value: '탈퇴 대기중'},
    {key: 2, value: '탈퇴 취소(사용자 요청)'},
    {key: 3, value: '탈퇴 완료(사용자 요청)'},
    {key: 4, value: '탈퇴 취소(관리자 요청)'},
    {key: 5, value: '탈퇴 완료(관리자 요청)'},
];

export function userWithdrawal(key) {
    const type = WITHDRAWAL_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}

export const ENGINE_SOCKET = [
    {key: 10001, value: 'Normal'},
    {key: 10002, value: 'Rare'},
    {key: 10003, value: 'Elite'},
    {key: 10004, value: 'Epic'},
    {key: 10005, value: 'Ultimate'},
];

export function getEngineName(key) {
    const type = ENGINE_SOCKET?.find(item => item.key === key);
    return type ? type?.value : key;
}

// 0이아닌 토큰 표기 함수
export const getPriceText = (row, decimalPlaces) => {
    const tokenTypes = ['Per', 'Xper', 'Hvh', 'Usdt', 'Arb'];
    const priceKey = tokenTypes.find((type) => {
        const key = `price${type}`;
        return row[key] > 0;
    });

    if (!priceKey) {
        return '';
    }

    let price;

    if (priceKey === 'Usdt') {
        price = (row[`price${priceKey}`] / 10 ** 6).toFixed(decimalPlaces);
    } else {
        price = convertBigNumToDecimalString(row[`price${priceKey}`], decimalPlaces);
    }

    return `${price} ${priceKey.toUpperCase()}`;
};




export const WALLET_CONNECTION_TYPE = [
    {key: 1, value: 'CONNECTED'},
    {key: 2, value: 'DISCONNECTED'},
];

export function getWalletConnectionTypeName(key) {
    const type = WALLET_CONNECTION_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}

export const NETWORK_TYPE = [
    {key: 1, value: 'HAVAH'},
    {key: 2, value: 'EVM'},
];

export function getNetworkTypeName(key) {
    const type = NETWORK_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}


export function convertFalsyToHyphen(data) {
    return !data || data === "0" ? "-" : data;
}
